/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Review_TitleInputs */

const en_us2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this one good?`)
};

const pt_br2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa ficou boa?`)
};

const es_419_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quedó bien esta?`)
};

const pt_pt2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ficou boa?`)
};

const fr_fr2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle est bonne ?`)
};

const de_de2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passt das so?`)
};

const it_it2_body_assessment_review_title = /** @type {(inputs: Body_Assessment_Review_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Va bene questa?`)
};

/**
* | output |
* | --- |
* | "Is this one good?" |
*
* @param {Body_Assessment_Review_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_review_title = /** @type {((inputs?: Body_Assessment_Review_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Review_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_review_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_review_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_review_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_review_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_review_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_review_title(inputs)
	return en_us2_body_assessment_review_title(inputs)
});
export { body_assessment_review_title as "body-assessment.review_title" }